// Header / drawer cart badge: same rules as `snippets/cart-badge-item-count.liquid`.
(function () {
  function filteredCartItemCount(cart) {
    const items = (cart && cart.items) || [];
    let n = 0;
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const type = String((it && it.product_type) || '').trim().toLowerCase();
      const handle = String((it && it.handle) || '').trim().toLowerCase();
      if (type === 'easify_addon_product') continue;
      if (handle === 'setup-fee') continue;
      const qty = parseInt(String((it && it.quantity) != null ? it.quantity : 0), 10);
      if (Number.isFinite(qty) && qty > 0) n += qty;
    }
    return n;
  }

  window.zocoFilteredCartItemCount = filteredCartItemCount;

  function applyHeaderCartBadge(cart) {
    const n = filteredCartItemCount(cart);
    const el = document.querySelector('.site-header-cart--count');
    if (el) {
      el.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      el.classList.toggle('visible', n > 0);
    }
    const spBadge = document.querySelector('.sp-badge-item.sp-cart-count');
    if (spBadge) spBadge.textContent = n > 0 ? String(n) : '';
    const spHeading = document.querySelector('.sp-drawer-cart-heading .sp-cart-count');
    if (spHeading) spHeading.textContent = n > 0 ? '(' + String(n) + ')' : '';
  }

  function fetchCartAndSyncBadge() {
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(applyHeaderCartBadge)
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', fetchCartAndSyncBadge);
  document.addEventListener('product-form:cart:update', function (e) {
    if (e.detail && e.detail.cart) applyHeaderCartBadge(e.detail.cart);
  });

  function urlIsCartMutationAjax(u) {
    return /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/i.test(String(u || ''));
  }

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function' && !window.__cartBadgeFetchPatched) {
    window.__cartBadgeFetchPatched = true;
    window.fetch = function (input, init) {
      return nativeFetch.call(this, input, init).then(function (res) {
        try {
          const u = typeof input === 'string' ? input : input && input.url;
          const us = String(u || '');
          if (res.ok && us && /\/cart\.js(\?|$)/.test(us)) {
            res
              .clone()
              .json()
              .then(applyHeaderCartBadge)
              .catch(() => {});
          }
          if (
            res.ok &&
            us &&
            !window.__cartAddonMergeInsideRunOnce &&
            urlIsCartMutationAjax(us) &&
            typeof window.__cartAddonMergeSchedule === 'function'
          ) {
            window.__cartAddonMergeSchedule();
          }
        } catch (err) {}
        return res;
      });
    };
  }
})();

